// noinspection JSUnusedGlobalSymbols

import * as Apollo from '@apollo/client';

import { gql } from '@apollo/client';
import type * as Types from '../../__generated__/types';

const defaultOptions = {} as const;
export type DeleteEmployeeListCustomFilterMutationVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;

export type DeleteEmployeeListCustomFilterMutation = { __typename?: 'Mutation' } & Pick<
  Types.Mutation,
  'deleteEmployeeListCustomFilter'
>;

export const DeleteEmployeeListCustomFilterDocument = /*#__PURE__*/ gql`
    mutation deleteEmployeeListCustomFilter($id: ID!) {
  deleteEmployeeListCustomFilter(id: $id)
}
    `;
export type DeleteEmployeeListCustomFilterMutationFn = Apollo.MutationFunction<
  DeleteEmployeeListCustomFilterMutation,
  DeleteEmployeeListCustomFilterMutationVariables
>;

/**
 * __useDeleteEmployeeListCustomFilterMutation__
 *
 * To run a mutation, you first call `useDeleteEmployeeListCustomFilterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteEmployeeListCustomFilterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteEmployeeListCustomFilterMutation, { data, loading, error }] = useDeleteEmployeeListCustomFilterMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteEmployeeListCustomFilterMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteEmployeeListCustomFilterMutation,
    DeleteEmployeeListCustomFilterMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<DeleteEmployeeListCustomFilterMutation, DeleteEmployeeListCustomFilterMutationVariables>(
    DeleteEmployeeListCustomFilterDocument,
    options,
  );
}
export type DeleteEmployeeListCustomFilterMutationHookResult = ReturnType<
  typeof useDeleteEmployeeListCustomFilterMutation
>;
export type DeleteEmployeeListCustomFilterMutationOptions = Apollo.BaseMutationOptions<
  DeleteEmployeeListCustomFilterMutation,
  DeleteEmployeeListCustomFilterMutationVariables
>;
